export const WEBSITE_CONTENT_LOCKED_STATE = "digitalsuite_website_content_locked";

/** Locked touch-hook dummy page (LNX-702) always opens on the Folders tab. */
export const WEBSITE_CONTENT_LOCKED_SELECTED_TAB = "Folders";
